import { Automations } from './Automations';
import AutomationCTA from './AutomationCTA';
import MarketplaceCTA from './MarketplaceCTA';

const AutomationRouter = props => {
  const { isTeamLicense, marketplace = false } = props;
  if (marketplace && isTeamLicense) return <MarketplaceCTA />;
  return isTeamLicense ? <AutomationCTA /> : <Automations />;
};

export default AutomationRouter;
